import { createSlice } from '@reduxjs/toolkit';
const initState = {
  list: {},
  currChapter: {
    id: null,
    details: {},
  },
};

export const chapterSlice = createSlice({
  name: 'chapter',
  initialState: initState,
  reducers: {
    UPDATE_CHAPTERS: (state, action) => {
      state.list = action.payload;
    },
    UPDATE_CHAPTER_BY_ID: (state, action) => {
      const { id, data } = action.payload;
      state.list = {
        ...state.list,
        [id]: data,
      };
    },
    SET_CURR_CHAPTER: (state, action) => {
      state.currChapter = {
        id: action.payload,
        details:
          action.payload <= Object.keys(state.list).length
            ? state.list[action.payload]
            : {},
      };
    },
    SET_NEXT_CHAPTER: (state, action) => {},
    SET_PREV_CHAPTER: (state, action) => {},
  },
});

export const {
  UPDATE_CHAPTERS,
  UPDATE_CHAPTER_BY_ID,
  SET_CURR_CHAPTER,
  SET_NEXT_CHAPTER,
  SET_PREV_CHAPTER,
} = chapterSlice.actions;

export default chapterSlice.reducer;
